import type { BaseSchemas } from "api-types";

import { customerPath, isCustomerPathName } from "../../../paths";

const resolveItem = (item: BaseSchemas.BaseNavItem, customerDomain: string): BaseSchemas.BaseNavItem => {
  if (!item.route || !isCustomerPathName(item.route)) {
    return item;
  }
  const path = customerPath(item.route, { customerDomain });
  return {
    ...item,
    path: item.dynamicRouteId ? `${path}/${encodeURIComponent(item.dynamicRouteId)}` : path,
    alternativePaths: (item.alternativeRoutes ?? []).flatMap((route) =>
      isCustomerPathName(route) ? [customerPath(route, { customerDomain })] : []
    ),
  };
};

export const resolveCustomerNavPaths = (items: BaseSchemas.NavItem[], customerDomain: string): BaseSchemas.NavItem[] =>
  items.map((item) => ({
    ...resolveItem(item, customerDomain),
    subItems: item.subItems?.map((child) => resolveItem(child, customerDomain)),
  }));
